import { render } from "./ClientDocumentosEmitidos.vue?vue&type=template&id=2c713484&scoped=true"
import script from "./ClientDocumentosEmitidos.vue?vue&type=script&lang=js"
export * from "./ClientDocumentosEmitidos.vue?vue&type=script&lang=js"

import "./ClientDocumentosEmitidos.vue?vue&type=style&index=0&id=2c713484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c713484"]])

export default __exports__